var _g, _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchconfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_163_139437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.660492 15.4696C-0.220163 13.941 -0.220164 12.059 0.660491 10.5304L5.29982 2.47756C6.18294 0.944662 7.81739 9.32214e-08 9.58647 1.14318e-07L18.8467 2.24745e-07C20.6158 2.45841e-07 22.2503 0.944662 23.1334 2.47756L27.7727 10.5304C28.6534 12.059 28.6534 13.941 27.7727 15.4696L23.1334 23.5224C22.2503 25.0553 20.6158 26 18.8467 26L9.58647 26C7.81739 26 6.18294 25.0553 5.29982 23.5224L0.660492 15.4696Z",
    fill: "url(#paint0_linear_163_139437)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.2677,
    cy: 12.2462,
    r: 4.99039,
    fill: "#E9BE5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3891 15.2987C19.1406 14.0635 19.4134 12.5957 19.1559 11.1729C18.8983 9.75015 18.1283 8.47109 16.9915 7.57771C15.8546 6.68432 14.4297 6.23855 12.9864 6.32472C11.5431 6.41089 10.1814 7.02303 9.15892 8.04534C8.13739 9.06803 7.52592 10.4295 7.44012 11.8725C7.35432 13.3154 7.80012 14.7398 8.69326 15.8763C9.5864 17.0129 10.865 17.7828 12.2873 18.0406C13.7096 18.2984 15.1771 18.0262 16.4123 17.2755L18.4131 19.2763C18.6752 19.5384 19.0308 19.6857 19.4015 19.6857C19.7722 19.6857 20.1278 19.5384 20.3899 19.2763C20.6521 19.0141 20.7993 18.6586 20.7993 18.2878C20.7993 17.9171 20.6521 17.5616 20.3899 17.2994L18.3891 15.2987ZM9.93449 15.6287C9.48747 15.1817 9.13288 14.651 8.89096 14.067C8.64904 13.483 8.52452 12.857 8.52452 12.2248C8.52452 11.5926 8.64904 10.9667 8.89096 10.3826C9.13288 9.79858 9.48747 9.26791 9.93449 8.8209C10.8373 7.91813 12.0617 7.41096 13.3384 7.41096C14.6151 7.41096 15.8395 7.91813 16.7423 8.8209C17.6451 9.72368 18.1523 10.9481 18.1523 12.2248C18.1523 13.5015 17.6451 14.7259 16.7423 15.6287C14.8654 17.5056 11.8114 17.5056 9.93449 15.6287ZM19.6143 18.5007C19.5573 18.5562 19.481 18.5872 19.4015 18.5872C19.322 18.5872 19.2456 18.5562 19.1886 18.5007L17.2997 16.6118C17.3739 16.5447 17.4466 16.4755 17.5178 16.4043C17.5891 16.3331 17.6583 16.2604 17.7253 16.1861L19.6143 18.075C19.6701 18.1318 19.7014 18.2082 19.7014 18.2879C19.7014 18.3675 19.6701 18.4439 19.6143 18.5007Z",
    fill: "#E9BE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9686 10.7956C15.9411 10.729 15.9007 10.6686 15.8497 10.6176C15.7988 10.5667 15.7383 10.5263 15.6718 10.4988C15.6053 10.4712 15.5339 10.457 15.4619 10.457C15.3899 10.457 15.3186 10.4712 15.2521 10.4988C15.1855 10.5264 15.1251 10.5668 15.0741 10.6177L12.8505 12.8413L11.6608 11.6516C11.558 11.5487 11.4185 11.4909 11.273 11.4909C11.1276 11.4909 10.9881 11.5487 10.8852 11.6516C10.7824 11.7544 10.7246 11.8939 10.7246 12.0394C10.7246 12.1848 10.7824 12.3243 10.8852 12.4272L12.4627 14.0047C12.5136 14.0556 12.5741 14.096 12.6406 14.1236C12.7072 14.1511 12.7785 14.1653 12.8505 14.1653C12.9225 14.1653 12.9939 14.1511 13.0604 14.1236C13.1269 14.096 13.1874 14.0556 13.2383 14.0047L15.8497 11.3932C15.9007 11.3423 15.9411 11.2819 15.9686 11.2153C15.9962 11.1488 16.0104 11.0775 16.0104 11.0054C16.0104 10.9334 15.9962 10.8621 15.9686 10.7956Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_163_139437",
    x: -2.35461,
    y: -2.35461,
    width: 33.1428,
    height: 30.7092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.17731
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_163_139437"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_163_139437",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.362248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.181124
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_163_139437"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.07911
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_163_139437",
    result: "effect3_innerShadow_163_139437"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_163_139437",
    x1: 1.55023e-7,
    y1: 13,
    x2: 28.4332,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchconfirm);
export default __webpack_public_path__ + "static/media/searchconfirm.bdcd9c9bc0ffc1c2e9cccd83097540a7.svg";
export { ForwardRef as ReactComponent };